import {jsx as _jsx} from "react/jsx-runtime";import ReactDOM from "react-dom";

import App from "./App";
import "./index.css";
import "./WorkerClient";

ReactDOM.render(_jsx(App, {} ), document.getElementById("root"));
